import React, { useEffect, useRef, useState } from "react";
import styles from "./offers.module.scss";
import { Outlet } from "react-router-dom";
import NavTabs from "../../components/mui/tabs/NavTab";
import StatusCard from "../../components/uiComponents/statusCard/StatusCard";
import { useDispatch } from "react-redux";
import { getAllCategory, getAllProduct } from "../../store/actions";
const tabs = [
  {
    id: "1",
    title: "Active",
    link: "/offer",
  },
  {
    id: "2",
    title: "InActive",
    link: "/offer/inActive",
  },
];

const Offers = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllProduct());
    dispatch(getAllCategory());
  });
  return (
    <div className={styles.container}>
      <StatusCard
        leftContent="OFFERS" // or any icon/component
      />
      <div className={styles.top}>
        <NavTabs data={tabs} variant={"fullWidth"} />
      </div>

      <div className={styles.bottom}>
        <Outlet />
      </div>
    </div>
  );
};

export default Offers;
